import React from 'react';

interface GreenCheckProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const GreenCheck: React.FC<GreenCheckProps> = (props) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5 15C27.5 21.9036 21.9036 27.5 15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15ZM20.0379 11.2121C20.404 11.5782 20.404 12.1718 20.0379 12.5379L13.7879 18.7879C13.4218 19.154 12.8282 19.154 12.4621 18.7879L9.96209 16.2879C9.59597 15.9218 9.59597 15.3282 9.96209 14.9621C10.3282 14.596 10.9218 14.596 11.2879 14.9621L13.125 16.7992L15.9185 14.0056L18.7121 11.2121C19.0782 10.846 19.6718 10.846 20.0379 11.2121Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default GreenCheck;
